<template>
  <div
    class="app-tile"
    :class="{
      'app-tile_disabled': props.disabled,
    }"
  >
    <router-link
      :to="props.route"
      class="app-tile__link"
      :style="`--border-color: ${props.borderColor};`"
    >
      <div class="app-tile__content">
        <component
          :is="props.icon"
          v-if="typeof props.icon !== 'string'"
          class="app-tile__content-icon"
        />
        <i
          v-else
          class="app-tile__content-icon"
          :class="props.icon"
        />

        <div class="app-tile__content-text">
          <span
            class="typo-font-3"
          >
            {{ props.title }}
          </span>

          <small v-if="!isNullish(props.subtitle)">
            {{ props.subtitle }}
          </small>
        </div>

        <slot name="actions" />
      </div>
    </router-link>
  </div>
</template>

<script lang="ts" setup>

import {
  CSSProperties, FunctionalComponent, SVGAttributes,
} from 'vue';
import {
  RouteLocationRaw,
} from 'vue-router';

import {
  isNullish,
} from '../../utils/common';

export type TAppTileProps = {
  route: RouteLocationRaw,
  title: string,
  subtitle?: string,
  icon: string | FunctionalComponent<SVGAttributes, any, any, any>,
  borderColor: CSSProperties['color'],
  disabled?: boolean,
};

const props = defineProps<TAppTileProps>();
</script>

<style lang="scss" scoped>
.app-tile {
  --border-color: var(--color-103);

  position: relative;
  width: 100%;
  height: 3.875rem;
  border-radius: 0.25rem;
  overflow: hidden;
  border: 1px solid var(--color-103);
  display: flex;
  justify-content: space-between;

  &_disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }

  &__link {
    display: flex;
    padding: var(--gap);
    justify-content: space-between;
    border-left: 0.75rem solid var(--border-color);
    flex-grow: 1;
    text-decoration: none;
    color: var(--color-224)
  }

  &__pin-button {
    padding: var(--gap);
    color: var(--color-232);
  }

  &__content {
    height: 100%;
    display: flex;
    align-items: center;
    gap: var(--gap-union);
  }

  &__content-icon {
    width: 1.875rem;
    height: 1.875rem;
    font-size: 1.875rem;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-224);
  }

  &__content-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    small {
      color: var(--color-text-secondary)
    }
  }

  &__pin-icon {
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
